import { ItemTypeConsts } from 'client/util/Constants';
import { trialPropsData } from 'client/util/Constants/FeatureTrialConstants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const AppAuthorizationAsidePanel = () => import('client/Security/AppAuthorization/AppAuthorizationAsidePanel.vue');
const AuthNPoliciesAsidePanelWrapper = () => import('client/Security/AuthNPoliciesAsidePanel/AuthNPoliciesAsidePanelWrapper.vue');
const AuthNPoliciesMainPanel = () => import('client/Security/AuthNPoliciesMainPanel.vue');
const AuthNPoliciesSettings = () => import('client/Security/AuthNPoliciesSettings.vue');

const AuthNPoliciesProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.authNPolicies,
    noRedirect: false,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.authNPolicies,
    isAsideOpen: false,
    itemType: ItemTypeConsts.authNPolicies,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const AuthNPoliciesSettingsProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.appAuthorization,
  },
  mainPanel: {
    isAsideOpen: false,
    itemType: ItemTypeConsts.authNPoliciesSettings, // appAuthorization?
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Conditional Access Policies',
  feature: 'zeroTrust',
  modalProps: trialPropsData.zeroTrust,
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.authNPolicies].learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.authNPolicies].mainText[0].text,
  },
};

export default [
  // authNPolicies settings routes
  {
    path: '/security/authnpolicies/settings',
    name: 'authNPoliciesSettingsPanel',
    meta: metaData,
    components: {
      mainPanel: AuthNPoliciesSettings,
    },
    props: {
      mainPanel: AuthNPoliciesSettingsProps.mainPanel,
    },
  },
  {
    path: '/security/authnpolicies/settings/trustedApp/new',
    name: 'appAuthorizationNewTrustedApp',
    meta: metaData,
    components: {
      mainPanel: AuthNPoliciesSettings,
      asidePanel: AppAuthorizationAsidePanel,
    },
    props: {
      mainPanel: AuthNPoliciesSettingsProps.mainPanel,
      asidePanel: AuthNPoliciesSettingsProps.asidePanel,
    },
  },
  {
    path: '/security/authnpolicies/settings/trustedApp/:id/edit',
    name: 'appAuthorizationEditTrustedApp',
    meta: metaData,
    components: {
      mainPanel: AuthNPoliciesSettings,
      asidePanel: AppAuthorizationAsidePanel,
    },
    props: {
      mainPanel: AuthNPoliciesSettingsProps.mainPanel,
      asidePanel: route => ({
        ...AuthNPoliciesSettingsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  // authNPolicies routes
  {
    path: '/security/authnpolicies',
    name: 'authNPoliciesMainPanel',
    meta: metaData,
    components: {
      mainPanel: AuthNPoliciesMainPanel,
    },
    props: {
      mainPanel: AuthNPoliciesProps.mainPanel,
    },
  },
  {
    path: '/security/authnpolicies/:id',
    name: 'authNPoliciesDetails',
    meta: metaData,
    components: {
      mainPanel: AuthNPoliciesMainPanel,
      // wrapper to allow FF for new and legacy aside panel
      asidePanel: AuthNPoliciesAsidePanelWrapper,
    },
    props: {
      mainPanel: AuthNPoliciesProps.mainPanel,
      asidePanel: route => ({
        ...AuthNPoliciesProps.asidePanel,
        itemId: route.params.id === 'new' ? undefined : route.params.id,
      }),
    },
  },
];
